import { BlankLayout } from '@/components/layouts';

export default {
  path: '/scheme',
  name: 'Scheme',
  component: BlankLayout,
  meta: { module: '方案' },
  children: [
    {
      path: '/scheme/:id',
      name: 'Scheme.Details',
      component: () => import(/* webpackChunkName: "scheme-details" */ '../../views/scheme/SchemeDetails.vue'),
      meta: { title: '方案_3D方案详情' },
    },
    {
      path: '/scheme/custom/:id',
      name: 'Scheme.Custom.Details',
      component: () => import(/* webpackChunkName: "scheme-custom-details" */ '../../views/scheme/CustomSchemeDetails.vue'),
      meta: { title: '方案_自定义方案详情' },
    },
    {
      path: '/scheme/origin/:id',
      name: 'Origin.Scheme.Details',
      component: () => import(/* webpackChunkName: "origin-scheme-details" */ '../../views/scheme/OriginSchemeDetails.vue'),
      meta: { title: '我的设计_方案详情_3D方案' },
    },
    {
      path: '/scheme/origin/custom/:id',
      name: 'Origin.Scheme.Custom.Details',
      component: () => import(/* webpackChunkName: "origin-scheme-custom-details" */ '../../views/scheme/OriginCustomSchemeDetails.vue'),
      meta: { title: '我的设计_方案详情_自定义方案' },
    },
    {
      path: '/scheme/designer/:id',
      name: 'Designer.Scheme.Details',
      component: () => import(/* webpackChunkName: "designer-scheme-details" */ '../../views/scheme/DesignerSchemeDetails.vue'),
      meta: { title: '设计师主页_3D方案详情' },
    },
    {
      path: '/scheme/designer/custom/:id',
      name: 'Designer.Scheme.Custom.Details',
      component: () => import(/* webpackChunkName: "designer-scheme-custom-details" */ '../../views/scheme/DesignerCustomSchemeDetails.vue'),
      meta: { title: '设计师主页_自定义方案详情' },
    },
    {
      path: '/scheme/meitu/:id',
      name: 'Scheme.MeiTu.Details',
      component: () => import(/* webpackChunkName: "meitu-details" */ '../../views/scheme/MeiTuDetails.vue'),
      meta: { title: '美图详情页' },
    },
    {
      path: '/scheme/column/:id',
      name: 'Scheme.Column.Details',
      component: () => import(/* webpackChunkName: "column-details" */ '../../views/scheme/ColumnDetails.vue'),
      meta: { title: '方案专栏详情页' },
    },
    {
      path: '/scheme/pano/:id',
      name: 'Scheme.Panorama',
      component: () => import(/* webpackChunkName: "panorama" */ '../../views/scheme/Panorama.vue'),
      meta: { title: '全景体验', hideBanner: true },
    },
  ],
};
